import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { InterfaceListPageContext, InterfaceListPageInitialState } from ".";

export const InterfaceListPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(InterfaceListPageInitialState);

  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InterfaceListPageContext.Provider value={context}>
      {children}
    </InterfaceListPageContext.Provider>
  );
};
